import { useState, useEffect } from 'react';
import { JSONContent } from '@tiptap/core';
import debounce from 'lodash/debounce';

import { useRichtext } from 'approot/shared/richtext/richtext.hooks';
import { Settings } from 'approot/shared/richtext/richtext.utils';

export const useComponentRichtext = ({
  settings,
  initialValue,
  onChange,
}: {
  settings: Settings;
  initialValue?: JSONContent;
  onChange: (value: JSONContent) => void;
}) => {
  const [editorStateToUpdate, setEditorStateToUpdate] = useState<
    JSONContent | undefined
  >();

  const debounceOnChange = debounce((json: JSONContent) => {
    setEditorStateToUpdate(json);
  }, 300);

  const richtextProps = useRichtext({
    onChange: json => debounceOnChange(json),
    settings,
    initialValue,
  });

  // the use effect allows the latest props to be passed into the update
  useEffect(() => {
    if (editorStateToUpdate) onChange(editorStateToUpdate);
    setEditorStateToUpdate(undefined);
    // eslint-disable-next-line
  }, [editorStateToUpdate]);

  return {
    ...richtextProps,
  };
};
